import React from "react";

import dompurify from "isomorphic-dompurify";

import { ChevronDownIcon } from "@jti/brand-icons/chevron-down";
import { type MultiPackProduct } from "@jti/fe-common";

import "./ProductMultipacks.scss";

type ProductMultiPacksHeaderType = {
  item: MultiPackProduct;
};

const { sanitize } = dompurify;

export const ProductMultiPacksHeader = ({ item }: ProductMultiPacksHeaderType) => {
  if (!item) {
    return <React.Fragment />;
  }

  return (
    <button key={item.sku} className={"product-multipacks__header"}>
      <span className={"product-multipacks__header-title"}>{item.multiPackName}</span>
      {item.multiPackDescription && (
        <div
          className={"product-multipacks__header-description"}
          dangerouslySetInnerHTML={{ __html: sanitize(item.multiPackDescription) }}
        />
      )}
      <div className={"product-multipacks__header-icon"}>
        <ChevronDownIcon />
      </div>
    </button>
  );
};
